// tslint:disable: variable-name
import { ProdutoUnidade } from 'eddydata-lib';
import { BaseResourceModel } from '../../models/base-resource.model';
import { PacienteProcesso } from './paciente-processo.model';

export class PacienteItens extends BaseResourceModel {
  constructor(
    public id?: number,
    public qtde?: number,
    public paciente_processo?: PacienteProcesso,
    public produto_unidade?: ProdutoUnidade,
  ) {
    super();
  }
  static converteJson(json: any): PacienteItens {
    return Object.assign(new PacienteItens(), json);
  }
}
